export function concatWithDelimiter(textPieces, delimiter) {
  return textPieces.filter(Boolean).join(delimiter);
}
export var appendQueryParameter = function appendQueryParameter(actionLink, trackingParameter, zpid) {
  try {
    if (actionLink && trackingParameter) {
      var destinationUrl = new URL(actionLink);
      destinationUrl.searchParams.append('t', trackingParameter);

      if (zpid) {
        destinationUrl.searchParams.append('zpid', zpid);
      }

      return destinationUrl;
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }

  return actionLink;
};